import { Link } from "react-router-dom";

export default function Footer() {
  return (
      <footer className="bg-[#2E5984] text-white">
        <div className="mx-auto w-full max-w-[1200px] px-6 py-12 lg:px-0">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-4 lg:gap-12">
            {/* Logo */}
            <div className="flex justify-start">
              <Link to="/" className="inline-flex">
                <img
                    src="/img/logo_footer.png"
                    alt="YOGA 7 Logo"
                    className="h-[132px] w-[140px] object-contain"
                />
              </Link>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-roboto text-[18px] font-bold leading-[28px]">
                Quick Links
              </h3>

              <ul className="mt-4 space-y-2 font-roboto text-[16px] font-normal leading-[24px]">
                <li>
                  <Link to="/" className="hover:opacity-80">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/classes" className="hover:opacity-80">
                    Classes
                  </Link>
                </li>
                <li>
                  <Link to="/schedule" className="hover:opacity-80">
                    Schedule
                  </Link>
                </li>
                <li>
                  <Link to="/membership" className="hover:opacity-80">
                    Membership
                  </Link>
                </li>
                <li>
                  <Link to="/events-children" className="hover:opacity-80">
                    Events
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:opacity-80">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* About */}
            <div>
              <h3 className="font-roboto text-[18px] font-bold leading-[28px]">
                About
              </h3>

              <ul className="mt-4 space-y-2 font-roboto text-[16px] font-normal leading-[24px]">
                <li>
                  <Link to="/studio" className="hover:opacity-80">
                    Studio
                  </Link>
                </li>
                <li>
                  <Link to="/far-infrared-heat" className="hover:opacity-80">
                    Far Infrared Heat
                  </Link>
                </li>
                <li>
                  <Link to="/our-values-&-ethics" className="hover:opacity-80">
                    Our Values & Ethics
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="font-roboto text-[18px] font-bold leading-[28px]">
                Contact Info
              </h3>

              <div className="mt-4 space-y-3 font-roboto text-[14px] font-normal leading-[20px]">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line mt-[2px] text-white opacity-95" />
                  <p>
                    105-19925 Willowbrook Dr., Langley
                    <br />
                    Located near Willowbrook Shopping Centre
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-white opacity-95" />
                  <p>(778) 237-7790</p>
                </div>

                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-white opacity-95" />
                  <p>info@yogaseven.com</p>
                </div>
              </div>

              {/* Follow Us */}
              <div className="mt-6">
                <h4 className="font-roboto text-[14px] font-bold leading-[20px]">
                  Follow Us
                </h4>

                <div className="mt-3 flex items-center">
                  <a
                      href="https://www.instagram.com/yogasevenstudio?igsh=MWtsY3lhd2piZW5hcg%3D%3D&utm_source=qr"
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex h-[32px] w-[32px] items-center justify-center rounded-full bg-white"
                      aria-label="Instagram"
                  >
                    <i className="ri-instagram-line text-[14px] text-[#2E5984]" />
                  </a>

                  <a
                      href="https://www.facebook.com/profile.php?id=61585312964707"
                      className="ml-3 inline-flex h-[32px] w-[32px] items-center justify-center rounded-full bg-white"
                      aria-label="Facebook"
                  >
                    <i className="ri-facebook-fill text-[14px] text-[#2E5984]" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Divider + Bottom */}
          <div className="mx-auto w-full max-w-[831px] mt-10 border-t border-[#A5CEF7] pt-8">
            <p className="font-roboto text-[14px] font-normal leading-[20px] opacity-95">
              © 2025 YOGA 37. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
  );
}
